import { render, staticRenderFns } from "./YslabLogo.vue?vue&type=template&id=c14f48e2&scoped=true"
import script from "./YslabLogo.vue?vue&type=script&lang=js"
export * from "./YslabLogo.vue?vue&type=script&lang=js"
import style0 from "./YslabLogo.vue?vue&type=style&index=0&id=c14f48e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14f48e2",
  null
  
)

export default component.exports